import { Button, DataTable, Form, Modal, ResultsCard, ResultsToolbar, RowActions } from 'shared/components/ui';
import React, { useState, useEffect } from 'react';
import { Assignment, Add, Save } from '@mui/icons-material';

import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import ConfirmModal from '../../../shared/components/ConfirmModal';
import { Toast } from '../../../shared/components/Toast';
import { useRequisitos } from '../hooks/useRequisitos';
import '../../../features/turnos/components/GrillaTurnos.css';
import '../../../styles/buttons.css';

const GrillaRequisitos = () => {
  const { requisitos, loading, cargar, guardar, actualizar, eliminar } = useRequisitos();
  const [modal, setModal] = useState(null); // null | { mode: 'nuevo' | 'editar', item? }
  const [form, setForm] = useState('');
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => { cargar(); }, [cargar]);

  const abrirNuevo = () => { setForm(''); setModal({ mode: 'nuevo' }); };
  const abrirEditar = (item) => { setForm(item.requisito1); setModal({ mode: 'editar', item }); };

  const handleGuardar = async (e) => {
    e.preventDefault();
    try {
      if (modal.mode === 'editar') {
        await actualizar(modal.item.idRequisito, form);
        setToast({ message: 'Requisito actualizado con éxito.', type: 'success' });
      } else {
        await guardar(form);
        setToast({ message: 'Requisito guardado con éxito.', type: 'success' });
      }
      setModal(null);
      cargar();
    } catch {
      setToast({ message: 'Error al guardar.', type: 'error' });
    }
  };

  const confirmarEliminar = async () => {
    try {
      await eliminar(confirmEliminar.id);
      setToast({ message: 'Requisito eliminado con éxito.', type: 'success' });
      cargar();
    } catch {
      setToast({ message: 'Error al eliminar.', type: 'error' });
    } finally {
      setConfirmEliminar(null);
    }
  };

  return (
    <div className="grilla-turnos">
      <Header />
      <div className="main-content">
        <div className="page-header">
          <h2 className="page-title-grilla">
            <Assignment sx={{ fontSize: 32, mr: 1, verticalAlign: 'middle', color: '#6d1212' }} />
            Requisitos
          </h2>
          <span className="page-subtitle">Gestión del catálogo de requisitos</span>
        </div>

        <Modal show={modal !== null} onHide={() => setModal(null)}>
          <Modal.Header closeButton>
            <Modal.Title>{modal?.mode === 'editar' ? 'Editar Requisito' : 'Nuevo Requisito'}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleGuardar}>
            <Modal.Body style={{ padding: '1.5rem' }}>
              <div style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.4rem' }}>Requisito *</label>
                <input
                  className="form-control"
                  value={form}
                  onChange={(e) => setForm(e.target.value)}
                  maxLength={100}
                  placeholder="Ingrese el nombre del requisito..."
                  required
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModal(null)} disabled={loading}>Cancelar</Button>
              <Button type="submit" variant="success" disabled={loading || !form.trim()}>
                <Save sx={{ fontSize: 16, mr: 0.5 }} /> {modal?.mode === 'editar' ? 'Actualizar' : 'Guardar'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <ResultsCard className="results-card">
          <ResultsToolbar className="results-header">
            <div className="results-header-left"><h3 className="results-title">Resultados</h3></div>
            <div className="results-info">
              <span className="results-count">{requisitos.length} requisitos</span>
              {loading && <span className="loading-indicator">Cargando...</span>}
              <Button variant="success" size="sm" onClick={abrirNuevo} className="btn-new-turno">
                <Add sx={{ fontSize: 18, mr: 0.5 }} /> Nuevo Requisito
              </Button>
            </div>
          </ResultsToolbar>
          <div className="table-container table-container-scrollable">
            <DataTable className="data-table">
              <thead>
                <tr>
                  <th style={{ width: '80px' }}>Id</th>
                  <th>Requisito</th>
                  <th className="action-cell">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {requisitos.length === 0 ? (
                  <tr><td colSpan={3} className="empty-state">{loading ? 'Cargando...' : 'No hay requisitos disponibles'}</td></tr>
                ) : requisitos.map((r) => (
                  <tr key={r.idRequisito}>
                    <td style={{ color: '#64748b', fontSize: '0.85rem' }}>{r.idRequisito}</td>
                    <td>{r.requisito1}</td>
                    <td className="action-cell">
                      <RowActions onEdit={() => abrirEditar(r)} onDelete={() => setConfirmEliminar({ id: r.idRequisito, label: r.requisito1 })} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </div>
        </ResultsCard>
      </div>
      <Footer />

      <ConfirmModal
        show={confirmEliminar !== null}
        title="Eliminar Requisito"
        message={`¿Eliminar el requisito "${confirmEliminar?.label}"?`}
        onConfirm={confirmarEliminar}
        onCancel={() => setConfirmEliminar(null)}
      />
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};

export default GrillaRequisitos;
